"use client";

import InfoIcon from "@mui/icons-material/Info";
import { Menu } from "@mui/material";
import { useNavigate } from "react-router-dom";

import ROUTE_URLS from "@/constants/route-urls";
import useLanguage from "@/contexts/language-context";
import IImportation from "@/interfaces/importation.interface";
import { ImportationsMessages } from "@/messages/importations/importations.messages";
import NotificationItem from "@/mui/Items/NotificationItem";

interface Props {
  isOpen: boolean;
  anchorEl: (EventTarget & HTMLButtonElement) | null;
  onClose: () => void;
  messages: ImportationsMessages;
  selected: IImportation;
}

export function ImportationPopover({ isOpen, anchorEl, onClose, messages, selected }: Props) {
  const { lang } = useLanguage();
  const router = useNavigate();

  const handleDetails = () => router(ROUTE_URLS.importationDetails(lang, selected.id));

  return (
    <Menu
      open={isOpen}
      anchorEl={anchorEl}
      onClose={onClose}
      anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
    >
      <NotificationItem
        icon={<InfoIcon />}
        onClick={handleDetails}
        title={messages.importPopover}
      />
    </Menu>
  );
}
